<script lang="ts">
  import LoaderIcon from '$icons/loaders/LoaderIcon.svelte';
  import { createEventDispatcher, onMount } from 'svelte';
  export let hasMore = true;
  let loadingRef: HTMLElement | undefined;
  const dispatch = createEventDispatcher();
  onMount(() => {
    if (!loadingRef) {
      return;
    }
    const loadingObserver = new IntersectionObserver((entries) => {
      const element = entries[0];
      if (element.isIntersecting && hasMore) {
        dispatch('load-more');
      }
    });

    loadingObserver.observe(loadingRef);
  });
  export let loadingMore = true;
</script>

<div bind:this={loadingRef} class="h-px w-full" />
{#if loadingMore}
  <div class="flex h-20 w-full items-center justify-center">
    <LoaderIcon class="text-mint-dark-9" />
  </div>
{/if}
